import { generateRandomString } from './helper';

export const getGroupName = (groups, group_id) => {
  for (let index = 0; index < groups.length; index++) {
    const group = groups[index];

    if (group.group_id === group_id) {
      return group.groupName;
    }
  }
};
export const getGroupForId = (groups, group_id) => {
  for (let index = 0; index < groups.length; index++) {
    const group = groups[index];

    if (group.group_id === group_id) {
      return { group, index };
    }
  }
};

// Обєкт для створення інгридієнта
export const getObjectIngredient = () => {
  return {
    id: generateRandomString(),
    newIngredient: false, // true/false Тільки для фронтенда чи це інгридієнт який щойно додали
    text: '', //Кінцевий текст інгридієнта (який буде бачити клієнт)
    textIngredientDefault: '', //Назва інгидієнта
    titleIngredients: false, //[true/false] Вказує чи це заголовок чи інгридієнт

    valueIngredientDefault: '', //Дефолтне значення за яким буде розраховуватись КБЖВ (100, 1) за 100 грам/мілілітрів або за 1-штуку
    сaloriesProduct: '', //Калорійність (в 100 г,мл або за 1-шт)
    proteinProduct: '', //Білки (в 100 г,мл або за 1-шт)
    fatsProduct: '', //Жири (в 100 г,мл або за 1-шт)
    carbohydratesProduct: '', //Вуглеводи (в 100 г,мл або за 1-шт)

    сaloriesIngredient: '', //Калорійність інгридієнта для грам і мілілітрів (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct / 100) для штук (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct)
    proteinIngredient: '', //Білки інгридієнта для грам і мілілітрів (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct / 100) для штук (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct)
    fatsIngredient: '', //Жири інгридієнта для грам і мілілітрів (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct / 100) для штук (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct)
    carbohydratesIngredient: '', //Вуглеводи інгридієнта для грам і мілілітрів (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct / 100) для штук (сaloriesIngredient = onChangeIngredientValue * сaloriesProduct)

    roundingIngredientText: '', // Буде вказувати як округляти кількість інгридієнта сам текст
    roundingProductBasketText: '', // Буде вказувати як округляти кількість продукта сам текст
    roundinIngredientValue: '', // Буде вказувати як округляти кількість інгридієнта
    roundinProductBasketValue: '', // Буде вказувати як округляти кількість продукта
    onChangeIngredientValueRoundin: '', //Буде округлене число

    textBasketProductNameDefault: '', // Назва продукта для корзіни  без вказування його ваги (Крупа греча, Сметана 15% ...)
    textBasketProduct: '', // Назва продукта для корзіни з вказуванням його назви і ваги (Крупа греча 80 г, Сметана 15% 20г ...)
    unitBasket: '', // В чому вимірюється продукт який буде в корзіні (г, мл, шт,) ()
    unitIngredient: '', // Одиниця виміру для тексту інгридієнта (1 шт, г, ч.л, ст.л)
    unitText: '', //('100 г', "1 шт" ....) береться з обєкта unitsMeasurement в AddIngredients.js
    valueBasket: '', // onChangeIngredientValue * valueBaskeDefault Цифра кількість продукту яку потрібно купити для корзіни.
    ifAddBasket: true, // Чи додавати товар в корзіну
    valueCalculateForBasket: '', //Число на яке потрібно множити щоб отримати кількість продукту для корзіни (0.33)
    valueCalculateForIngredient: '', //Число на яке потрібно множити щоб отримати кількість продукту для інгридієнта (10)
    onChangeIngredientValue: '', // Число кількість інгридієнта (100, 1) (Каша гречана 100 г, 1 Яйце варене)
    orWillBeEditValueBasket: '', // [true/false] Чи показувати поле для додавання valueCalculateForBasket
    valueBaskeDefault: '', // Число (10, 20) якщо інгридієнт в чайних ложках чи столових то тут буде вказано його кількість
  };
};

// Обєкт для створення продукту
export const getProductObject = () => {
  return {
    productText: '',
    id: generateRandomString(),
  };
};
